<template>
    <div
        class="wellful-height flex w-full vx-row no-gutter items-center justify-center"
        id="page-login"
    >
        <div class="filter"></div>

        <vs-col class="w-full md:w-3/5 m-0 md:m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="flex justify-center bg mt-5">
                        <div class="hidden md:block md:w-1/2">
                            <div id="logo" class="flex justify-center">
                                <img
                                    src="@/assets/images/logo.png"
                                    class="wellful-logo-img mt-12"
                                    alt="Wellful Logo"
                                />
                            </div>

                            <img src="@/assets/images/croc.png" alt="Croc Image" class="croc" />
                        </div>

                        <div class="vx-col w-full md:w-1/2 d-theme-dark-bg">
                            <div class="p-8 login-tabs-container">
                                <vs-tabs v-model="step">
                                    <vs-tab>
                                        <sign-in
                                            :redirect="redirectto"
                                            :email.sync="email"
                                            @forgot="openForgot"
                                            @register="openRegistration"
                                        ></sign-in>
                                    </vs-tab>
                                    <vs-tab>
                                        <forgot-password
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></forgot-password>
                                    </vs-tab>
                                    <vs-tab>
                                        <register
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></register>
                                    </vs-tab>
                                    <vs-tab>
                                        <verify-email
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></verify-email>
                                    </vs-tab>
                                    <vs-tab>
                                        <activate
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></activate>
                                    </vs-tab>
                                    <vs-tab>
                                        <reset-password
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></reset-password>
                                    </vs-tab>
                                </vs-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </vs-col>
    </div>
</template>

<script>
import SignIn from './views/SignIn'
import ForgotPassword from './views/ForgotPassword'
import Register from './views/Register'
import VerifyEmail from './views/VerifyEmail'
import Activate from './views/Activate'
import ResetPassword from './views/ResetPassword'
import WellfulLogo from '../logo/WellfulLogo.vue'
import { mapQueries, mapParams } from '../../plugins/mappers'

export default {
    name: 'login',
    components: {
        SignIn,
        ForgotPassword,
        Register,
        VerifyEmail,
        Activate,
        ResetPassword,
        WellfulLogo
    },
    data() {
        return {
            email: '',
            stepMap: {
                login: 0,
                forgot: 1,
                register: 2,
                verify: 3,
                activate: 4,
                reset: 5
            },
            redirecting: false
        }
    },
    computed: {
        ...mapParams('action'),
        ...mapQueries('redirectto'),
        actions() {
            return Object.keys(this.stepMap)
        },
        reverseStepMap() {
            var ret = {}
            Object.keys(this.stepMap).forEach((key) => {
                ret[this.stepMap[key]] = key
            })
            return ret
        },
        step: {
            get() {
                return this.stepMap[this.action]
            },
            set(value) {
                if (this.step != value && !this.redirecting) {
                    var action = this.reverseStepMap[value]
                    if (this.$route.params.action != action) {
                        this.action = action
                    }
                }
            }
        }
    },
    methods: {
        openForgot() {
            this.step = 1
        },
        openRegistration() {
            this.step = 2
        },
        openSignIn() {
            this.step = 0
        },
        check_redirect() {
            if (!this.actions.includes(this.action)) {
                this.redirecting = true
                this.$router.replace({ name: '404' })
            }
        }
    }
}
</script>

<style scoped>
.vs-tabs ::v-deep .con-ul-tabs {
    display: none !important;
}
.clickable {
    cursor: pointer;
}
.filter {
    background-color: #293336;
    opacity: 0.8;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
}

/* .logo {
        margin: auto;
        max-width: 50%;
        max-height: 50%;
        height: 80%;
    } */
.wellful-height {
    height: calc(100vh - 323px);
}

.wellful-logo-img {
    height: auto;
    width: 80%;
    margin-bottom: 12rem;
}
.bg {
    background-color: #b7dcc9;
    height: 100%;
}
.croc {
    position: absolute;
    left: -50px;
    bottom: 0;
    height: 250px;
}
</style>
